import React from 'react';
import withStyles from 'react-jss';
import { Translation } from 'react-i18next';
import { getClassListStyle } from '../dragDropUtil';
import PlusIcon from '../../../../utility/PlusIcon';

const customInputStyles = {
  textTitleColor: (props) => ({
    color: props.tenant.primary,
  }),
  customInput: (props) => ({
    border: `2px solid ${props.tenant.primary}`,
  }),
};

class CustomClassMobile extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
    };
  }

  onInputChange = async (event) => {
    this.setState({
      title: event.target.value,
    });
  };

  createCustomClass = async (subjectSearching, columnInd) => {
    this.props.addClass({
      source: {
        droppableId: 'customClass',
        index: 0,
        title: this.state.title,
      },
      destination: {
        droppableId: `${subjectSearching}_${columnInd}`,
        index: columnInd,
      },
      course: {
        requirement_title: '',
        acadPlan: this.props.acadPlan,
        academic_area_id: 'Custom',
        titleEn: this.state.title,
      },
    });
  };

  render() {
    const { subjectSearching, columnInd, classes, inputText, tenant } =
      this.props;

    return (
      <Translation>
        {(t) => (
          <>
            <div className="class-list-header-line-container">
              <hr className="custom-class-horizontal-line" />
              <p
                className={[
                  'custom-class-title mobile',
                  classes.textTitleColor,
                ].join(' ')}
              >
                {t('Custom Class')}
              </p>
            </div>
            <div
              key="custom"
              className="custom-droppable classes-drag-drop-column"
              style={getClassListStyle(true)}
            >
              <div className="add-custom-container">
                <input
                  aria-label="custom-class-input"
                  placeholder={`${inputText}`}
                  className={[
                    'custom-class-input mobile',
                    classes.customInput,
                  ].join(' ')}
                  onChange={this.onInputChange}
                />
                <div
                  className="plus-container"
                  onClick={() => {
                    if (!this.state.title) return;
                    this.createCustomClass(subjectSearching, columnInd);
                  }}
                  onKeyDown={(e) => {
                    if (!this.state.title) return;
                    if (['Enter'].includes(e.key)) {
                      this.createCustomClass(subjectSearching, columnInd);
                    }
                  }}
                  role="button"
                  tabIndex="0"
                >
                  <PlusIcon color={tenant.primary} />
                </div>
              </div>
            </div>
          </>
        )}
      </Translation>
    );
  }
}

export default withStyles(customInputStyles)(CustomClassMobile);
